import {Affix} from '@mantine/core';
import React from 'react';
import {NavigationActionIcon} from 'src/design/molecules/NavigationActionIcon';

export interface FloatingSidebarToggleProps {
  onClick: () => void;
}

export const FloatingSidebarToggle: React.FC<FloatingSidebarToggleProps> = ({
  onClick,
}) => {
  return (
    <>
      <Affix
        display={{base: 'inherit', sm: 'none'}}
        position={{bottom: 30, right: 30}}>
        <NavigationActionIcon
          onClick={onClick}
          tooltipText="Toggle navigation"
          tooltipProps={{events: {hover: true, focus: false, touch: false}}}
        />
      </Affix>
    </>
  );
};
